import { render, staticRenderFns } from "./LabelInputDate.vue?vue&type=template&id=9b3b6d78&scoped=true&lang=pug&"
import script from "./LabelInputDate.vue?vue&type=script&lang=ts&"
export * from "./LabelInputDate.vue?vue&type=script&lang=ts&"
import style0 from "./LabelInputDate.vue?vue&type=style&index=0&id=9b3b6d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b6d78",
  null
  
)

export default component.exports